// src/features/reabertura/api.js
import api from "../../api/axios";

/**
 * REGRINHA DE OURO:
 * - Seu axios (../../api/axios) já está apontando para "/api"
 *   então aqui NÃO pode ter "/api/..." no começo.
 *
 * Rotas do backend:
 *   GET  /api/reabertura/finalizadas
 *   GET  /api/reabertura/wf3
 *   POST /api/reabertura/reabrir
 *
 * Aqui fica:
 *   "/reabertura/..."
 */

function pickError(data, fallback) {
  return data?.error || data?.message || fallback;
}

export async function listarFinalizadas({ from, to, code, limit = 2000 }) {
  const params = {
    from,
    to,
    limit: Number(limit) || 2000,
  };
  if (code && String(code).trim()) params.code = String(code).trim();

  const { data } = await api.get("/reabertura/finalizadas", { params });

  if (!data?.ok) throw new Error(pickError(data, "Falha ao listar finalizadas"));
  return Array.isArray(data.items) ? data.items : [];
}

export async function listarWf3All({ code, limit = 2000, offset = 0 }) {
  const params = {
    limit: Number(limit) || 2000,
    offset: Number(offset) || 0,
  };
  if (code && String(code).trim()) params.code = String(code).trim();

  const { data } = await api.get("/reabertura/wf3", { params });

  if (!data?.ok) throw new Error(pickError(data, "Falha ao listar WF_3"));
  return Array.isArray(data.items) ? data.items : [];
}

export async function reabrirProgramacoes({ ids, reason }) {
  const payload = { ids, reason };

  const { data } = await api.post("/reabertura/reabrir", payload);

  // backend pode devolver {ok:false,...} com status 200 ou 4xx/5xx dependendo do teu middleware
  if (data?.ok === false) throw new Error(pickError(data, "Falha ao reabrir"));
  return data; // { ok:true, ... }
}
